import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AboutPage } from './pages/AboutPage';
import { ContestPage } from './pages/ContestPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
        <Route path="/contest" element={<ContestPage data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}